/* Packages */
import React from 'react';
import { render } from 'react-dom';

const productOverviewNodes = Array.from(document.querySelectorAll('[data-product-overview]'));
if (productOverviewNodes.length) {
    import(/* webpackChunkName: "ProductOverview" */ './components/ProductOverview').then(({ default: ProductOverview }) => {
        productOverviewNodes.forEach((node) => render(<ProductOverview {...(JSON.parse(node.dataset.productOverview || '{}'))} />, node));
    });
}